import React, { useEffect, useRef } from "react";
import { createSearchParams, Outlet, useLocation, useNavigate } from "react-router-dom";
import stringUtils from "../_services/string-utils";

export const IGNORED_REDIRECT_PATHS = ["", "undefined", "/", "/login", "dologout"];

const PrivateRoute = (props) => {
    const isLoggedIn = localStorage.getItem("user");
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const redirectUrlRef = useRef(params.get("redirect_url"));
    const notificationIdRef = useRef(params.get("notificationId"));

    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn) {
            if (!redirectUrlRef.current) {
                if (!stringUtils.isBlank(location.pathname) && !IGNORED_REDIRECT_PATHS.includes(location.pathname)) {
                    redirectUrlRef.current = location.pathname + location.search;
                }
            } else if (!location.pathname.startsWith("/login")) {
                redirectUrlRef.current = redirectUrlRef.current.startsWith("/")
                    ? redirectUrlRef.current
                    : `/${redirectUrlRef.current}`;
            }

            if (redirectUrlRef.current && notificationIdRef.current) {
                const redirectParams = new URLSearchParams(redirectUrlRef.current.split("?")[1] || "");
                redirectParams.delete("notificationId");
                redirectUrlRef.current = redirectUrlRef.current.split("?")[0] + "?" + redirectParams.toString();
            }

            const searchParams = {};
            if (notificationIdRef.current) {
                searchParams.notificationId = notificationIdRef.current;
            }
            if (redirectUrlRef.current) {
                searchParams.redirect_url = redirectUrlRef.current;
            }

            navigate({
                pathname: "/login",
                search: createSearchParams(searchParams).toString(),
            });
        }
    }, [isLoggedIn, location, navigate]);

    if (isLoggedIn) {
        return <Outlet {...props} />;
    }

    return null;
};

export default PrivateRoute;
